import { Text } from "@/components/podkit/typography/Text";
import { WorkflowExecutionStatusPill } from "@/components/automations/AutomationExecutionStatusPill";
import { durationBetweenTimestamps, timeAgo } from "@/format/time";
import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import { Timestamp } from "@bufbuild/protobuf";
import type { FC, PropsWithChildren } from "react";

export const WorkflowExecutionSummary: FC<{ workflowExecution: PlainWorkflowExecution }> = ({ workflowExecution }) => {
    const duration =
        workflowExecution.metadata?.startedAt && workflowExecution.metadata?.finishedAt
            ? durationBetweenTimestamps(workflowExecution.metadata.startedAt, workflowExecution.metadata.finishedAt)
            : undefined;

    return (
        <div className="flex justify-between gap-4 self-stretch rounded-xl border border-border-base bg-surface-primary p-4">
            <MetaData label="Status">
                <WorkflowExecutionStatusPill execution={workflowExecution} />
            </MetaData>

            <MetaData label="Triggered on">
                <Text className="font-base content-primary">
                    {workflowExecution.metadata?.startedAt ? (
                        timeAgo(new Timestamp(workflowExecution.metadata?.startedAt).toDate())
                    ) : (
                        <span>-</span>
                    )}
                </Text>
            </MetaData>

            <MetaData label="Completed on">
                <Text className="font-base content-primary">
                    {workflowExecution.metadata?.finishedAt ? (
                        timeAgo(new Timestamp(workflowExecution.metadata?.finishedAt).toDate())
                    ) : (
                        <span>-</span>
                    )}
                </Text>
            </MetaData>

            <MetaData label="Duration">
                <Text className="font-base content-primary">{duration ? duration : <span>-</span>}</Text>
            </MetaData>
        </div>
    );
};

const MetaData: FC<PropsWithChildren & { label: string }> = ({ children, label }) => {
    return (
        <div className="flex w-44 shrink flex-col gap-1">
            <Text className="content-strong text-base">{label}</Text>
            {children}
        </div>
    );
};
